// extracted by mini-css-extract-plugin
module.exports = {"cookiePopup":"CookiePopup_cookiePopup__17phL","txt":"CookiePopup_txt__SaVz-","cookieLink":"CookiePopup_cookieLink__1MRa_","closePopup":"CookiePopup_closePopup__fRSSu"};